import { baseApi } from '~src/services/ApiController';

import { DeleteCompany } from './actionTypes';

export const deleteCompany = () => ({
  types: DeleteCompany,
  callAPI: () => baseApi.delete('/company'),
});
